import { render, staticRenderFns } from "./ScaleSampleFrequencies.vue?vue&type=template&id=b940e508&"
import script from "./ScaleSampleFrequencies.vue?vue&type=script&lang=js&"
export * from "./ScaleSampleFrequencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports